import { Button, notification, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { AuthContext } from "$context/AuthContextProvider";
import { useQueryClient } from "@tanstack/react-query";

const ImportFile = ({ url, text }) => {
  const queryClient = useQueryClient();
  const authContext = useContext(AuthContext);
  const props = {
    name: "file",
    multiple: true,
    action: `${process.env.REACT_APP_CALENDER_API}${url}`,
    showUploadList: false,
    accept: ".csv",
    headers: { Authorization: `Bearer ${authContext.bearerToken}` },
    onChange(info) {
      const { status } = info.file;
      if (status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (status === "done") {
        notification.success({
          message: `${info.file.name} Datei wurde erfolgreich eingelesen.`,
        });
      } else if (status === "error") {
        notification.error({
          message: `${info.file.name} Datei konnte nicht eingelesen werden.`,
        });
      }
      queryClient.invalidateQueries(["timeSlots"]);
    },
  };

  return (
    <Upload {...props}>
      <Button type="primary" icon={<UploadOutlined />}>
        {/* Zeitslots Importieren */}
        {text}
      </Button>
    </Upload>
  );
};

export default ImportFile;
